import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from './cn';

/**
 * Breadcrumb — items: [{ label, href? }]. Mục cuối là trang hiện tại (không link).
 */
export function Breadcrumb({ items = [], className }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center flex-wrap gap-1 text-sm', className)}>
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`} className="inline-flex items-center gap-1">
            {item.href && !last ? (
              <Link to={item.href} className="text-muted hover:text-brand-fg transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className={last ? 'text-heading font-medium' : 'text-muted'} aria-current={last ? 'page' : undefined}>
                {item.label}
              </span>
            )}
            {!last ? <ChevronRight className="w-3.5 h-3.5 text-muted/70" aria-hidden="true" /> : null}
          </span>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
